import React, { useState } from "react";
import { Link } from "react-router-dom";
import useAppContext from "state/AppContext";
import { ChevronDownIcon, ChevronUpIcon, ClockIcon, HomeIcon } from "@heroicons/react/24/solid";
import TimelineItem from "pages/OrdersView/OrderStatusPage/components/TimelineItem";
import { orderStages } from "assets/orderStages";

export default function OrderDashboardHiringTimeline() {
  const appContext = useAppContext();
  const customerName = appContext.currentUser.firstName;
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }

  const morningGreeting = `Good morning, ${customerName}!`;
  const afterNoonGreeting = `Good afternoon, ${customerName}!`;
  const eveningGreeting = `Good evening, ${customerName}!`;
  const titleGreeting =
    new Date().getHours() < 12 ? morningGreeting : new Date().getHours() < 17 ? afterNoonGreeting : eveningGreeting;
  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";

  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <ClockIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">The Hiring Timeline</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div className="p-6 flex flex-wrap">
          <ol className="relative border-l border-gray-200 dark:border-gray-700">
            {orderStages.map((stage) => (
              <TimelineItem stage={stage} key={stage.id} />
            ))}
          </ol>
        </div>
      ) : null}
    </div>
  );
}
